import { render, staticRenderFns } from "./IntegrationAWS.vue?vue&type=template&id=c7678ec8&scoped=true"
import script from "./IntegrationAWS.vue?vue&type=script&lang=js"
export * from "./IntegrationAWS.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7678ec8",
  null
  
)

export default component.exports